const StorageKey = 'frontier.tutorials.completed';

function readAll(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(StorageKey);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed.filter((x) => typeof x === 'string') as string[]) : [];
  } catch {
    return [];
  }
}

function writeAll(values: string[]) {
  if (typeof window === 'undefined') return;
  const unique = Array.from(new Set(values));
  window.localStorage.setItem(StorageKey, JSON.stringify(unique));
}

export const useTutorialsLocalStorage = () => {
  const has = (tutorialName: string) => readAll().includes(tutorialName);
  const add = (tutorialName: string) => {
    const current = readAll();
    if (!current.includes(tutorialName)) {
      writeAll([...current, tutorialName]);
    }
  };
  const remove = (tutorialName: string) => {
    const current = readAll();
    if (current.includes(tutorialName)) {
      writeAll(current.filter((x) => x !== tutorialName));
    }
  };
  const list = () => readAll();

  return { has, add, remove, list };
};
